import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ContentLoader } from '@saucelabs/sl-component-loader';

import * as actions from './../../actions';
import AppTestingForm from './AppTestingForm';

class AppTestingContainer extends PureComponent {
  componentDidMount() {
    const { getInitialData } = this.props;

    getInitialData();
  }

  render() {
    const { loading } = this.props;

    return (
      <ContentLoader show={loading}>
        <AppTestingForm />
      </ContentLoader>
    );
  }
}

const mapDispatchToProps = {
  getInitialData: actions.getInitialData,
};

const mapStateToProps = ({ apps: { manual: { loading } } }) => ({
  loading,
});

AppTestingContainer.propTypes = {
  getInitialData: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppTestingContainer);
export { AppTestingContainer, mapDispatchToProps };
